<template>
    <div class="modal__buttons__item w-auto px-3">
        <button type="button" style="border-top-right-radius: 0px; border-bottom-right-radius: 0px; padding-right:15px;" v-html="btn_label" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"/>
        <button type="button" class="dropdown-toggle dropdown-toggle-split ml-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="border-top-left-radius: 0px; border-bottom-left-radius: 0px; padding-right:0px;">
            <span class="sr-only"/>
        </button>
        <div class="dropdown-menu" :style="'font-size: 14px; padding:0; margin-top: 0px;'">
            <export-excel
                :class="'dropdown-item'"
                :data="empty_format_data"
                :fields="excel_file_headers"
                type="csv"
                :name="file_name !== undefined ? `${file_name}.csv` : 'template.csv'"
            >
            Download template file
            </export-excel>
            <a class="dropdown-item" v-html="'Upload File'" @click="show_input()"/>
        </div>
        <div v-show="false">
            <input
                type="file"
                ref="file_excel_input"
                :id="id"
                :class="'form-control'"
                style="height: 2rem; font-size:12px; color:black;"
                @change="file_upload($event)"
                accept=".xlsx, .xls, .csv"
            />
        </div>
        
    </div>
</template>

<script>

const reader = new FileReader();
import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {
    name: 'UploadOptions',

    props: {
        empty_format_data: Array,
        excel_file_headers: Object,
        file_name: String,
        btn_label: {
            type: String,
            default: 'Upload options'
        },
        id: {
            type: String,
            default: 'file_excel_input'
        },
    },

    data() {
        return {
            notyf,
        }
    },

    async created() {
    },
    
    methods: {
        show_input()
        {
            window.$(`#${this.id}`).click()
        },

        file_upload(event)
        {
            const file = event.target.files[0]
            if (file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || file.type === 'application/vnd.ms-excel' || file.type === 'text/csv')
            {
                reader.readAsBinaryString(file)
                reader.onload = (e) => {
                    const data = this.get_content_excel(e.target.result)
                    this.$emit('data', data)
                }
                // this.notyf.success("The file is compatible")
            }
            else 
            {
                this.notyf.error("The file is not compatible")
                return false
            }
        },

        clear_data()
        {
           this.$refs.file_excel_input.value = ""
        }

    },
    
}
</script>